import { LanguageEnums } from "models/enums";

export const IsCustomerInvoiceActive = "isCustomerInvoiceActive";
export const IsReceiptActive = "isReceiptActive";
export const IsSupplierInvoiceActive = "isSupplierInvoiceActive";
export const StandardDimension = "standardDimension";
export const DimensionList = "dimensionList";
export const ContactToActivate = "contactToActivate";
export const DefaultInvoiceLanguageCode = LanguageEnums.LanguageCodes.SV;

export const NavigationKey = {
  MyProfile: "myProfile",
  Company: "company",
  Invoice: "invoice",
  Employees: "employees",
  Dimensions: "dimensions",
  MonthlyReport: "monthlyReport",
  Integrations: "integrations",
  BankBalances: "bank",
  About: "about",
};
